import { usePostHog } from "posthog-js/react";
import { useEffect, useState } from "react";

interface IUseFeatureFlagOptions {
  defaultValue?: boolean;
}

export interface IUseFeatureFlagProps {
  featureFlagId?: string;
  featureFlagValue?: string | boolean;
  options?: IUseFeatureFlagOptions;
}

export default function useFeatureFlag(props: IUseFeatureFlagProps) {

  const posthog = usePostHog();
  const [ isFeatureFlagActive, setIsFeatureFlagActive ] = useState(props.options?.defaultValue ?? false);

  const updateCanDisplay = () => {
    if (!props.featureFlagId?.length) { return true; }
    const flagValue = posthog.getFeatureFlag(props.featureFlagId);
    setIsFeatureFlagActive(flagValue === props.featureFlagValue);
  };

  useEffect(() => {
    posthog?.onFeatureFlags(updateCanDisplay);
  }, [ posthog ]);

  return {
    isFeatureFlagActive,
  };

}
